import { useState, useCallback } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { pathwayTemplatesActions, usePathwayTemplatesSearch } from '@/stores/pathwayTemplatesStore';

const PathwayTemplatesSearch = () => {
  const [localQuery, setLocalQuery] = useState('');
  const { searchQuery, isSearching } = usePathwayTemplatesSearch();

  const handleSearch = useCallback(async () => {
    if (localQuery.trim()) {
      await pathwayTemplatesActions.searchPathwayTemplates(localQuery.trim());
    } else {
      await pathwayTemplatesActions.resetSearch();
    }
  }, [localQuery]);

  const handleInputChange = e => {
    setLocalQuery(e.target.value);
  };

  const handleReset = async () => {
    setLocalQuery('');
    await pathwayTemplatesActions.resetSearch();
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="flex items-center gap-2 mb-4">
      <div className="relative flex-1">
        <label className="input input-sm input-bordered">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" />
          </div>
          <input
            type="text"
            value={localQuery}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            placeholder="Search pathway templates..."
            className=" w-full pl-5"
            disabled={isSearching}
          />
          {isSearching && (
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
              <div className="loading loading-spinner loading-sm text-gray-400"></div>
            </div>
          )}
        </label>
      </div>
      <button onClick={handleSearch} disabled={isSearching} className="btn btn-accent btn-sm" type="button">
        Search
      </button>
      {searchQuery && (
        <button onClick={handleReset} className="btn btn-outline btn-sm" type="button">
          Clear
        </button>
      )}
    </div>
  );
};

export default PathwayTemplatesSearch;
